var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevroninline = function SvgChevroninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 34,
    fill: "none",
    viewBox: "0 0 19 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#141A1F",
    strokeWidth: 2,
    d: "m1 1 16 16L1 33"
  })));
};
export default SvgChevroninline;